import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { collectionTypes } from '@services/api'

export class collectionTypesStore extends StoreExt {
    @observable list = []
    @observable filteredList = []
    @observable error = null
    @observable filters = {
        name: ''
    }
    @observable editCollectionType = {}

    @action
    getCollectionTypes = async () => {
        const { data: list } = await collectionTypes.getList()
        runInAction(() => {
            this.list = list
            this.filterList()
        })
    }

    @action
    filterList = () => {
        this.filteredList = this.list.filter(
            value =>
                (!!value.name && value.name.includes(this.filters['name'])) ||
                value.id.toString() === this.filters['name']
        )
    }

    @action
    setFilter = (name, value) => {
        const newFilters = { ...this.filters }
        newFilters[name] = value
        runInAction(() => {
            this.filters = newFilters
            this.filterList()
        })
    }

    @action
    toggleCollectionType = collectionType => {
        if (this.editCollectionType['id'] !== collectionType.id) {
            this.editCollectionType = { ...collectionType }
        } else {
            this.editCollectionType = {}
        }
    }

    @action
    addCollectionType = async () => {
        await collectionTypes
            .addCollectionType({ ...this.editCollectionType })
            .then(() => {
                runInAction(() => {
                    this.getCollectionTypes()
                    this.resetEdit()
                })
            })
            .catch(e => {
                runInAction(() => {
                    if (e.response.status === 400) {
                        this.error = '* סוג זה כבר קיים'
                    } else {
                        this.error = 'שגיאה בחיבור לשרת'
                    }
                })
            })
    }

    @action
    updateCollectionType = async () => {
        await collectionTypes
            .updateCollectionType({ ...this.editCollectionType })
            .then(() => {
                runInAction(() => {
                    this.getCollectionTypes()
                    this.resetEdit()
                })
            })
            .catch(e => {
                runInAction(() => {
                    if (e.response.status === 400) {
                        this.error = '* סוג זה כבר קיים'
                    } else {
                        this.error = 'שגיאה בחיבור לשרת'
                    }
                })
            })
    }

    @action
    deleteCollectionType = async () => {
        await collectionTypes
            .deleteCollectionType(this.editCollectionType['id'])
            .then(() => {
                runInAction(() => {
                    this.getCollectionTypes()
                    this.resetEdit()
                })
            })
            .catch(e => {
                runInAction(() => {
                    this.error = 'שגיאה בהתחברות לשרת'
                })
            })
    }

    @action
    editValue = (name, value) => {
        this.editCollectionType[name] = value
    }

    @action
    resetEdit = () => {
        this.editCollectionType = {}
        this.error = null
    }
}

export default remotedev(new collectionTypesStore())
